'use strict';

angular.module('transport.constants', [])
    .constant('transportModuleEnum', {
        ModuleId: 5
    });